<!--  -->
<template>
    <div class='About_ISFAL'>
        <div class="title_box">
            <img src="../../assets/images/isfal/bj_05.jpg" alt="">
        </div>
        <div class="Certification_System">
            <div class="Certification_System_box">
                <div class="System_box_1">
                    <div class="System_box_1_left">
                        <p class="System_box_1_left_1 active" >Leadership Development</p>
                        <p class="System_box_1_left_1 " @click="onOfficers">Organizational Development</p>
                        <p class="System_box_1_left_1 " @click="onSearch">Social Development</p>
                        <p class="System_box_1_left_1 " @click="onResearch">Professional Research</p>
                    </div>
                    <div class="System_box_1_right" >
                        <div class="Methodological">
                            <div class="Methodological_1" v-for="(item,index) in list" :key="index" @click="ondel(item)">{{ item.title }}  </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/About_ISFAL.less"
    export default {
        name: '',
        data() {
            //这里存放数据
            return {
                list:[]
            }
        },
        components: {},

        //方法集合
        methods: {
            artlist() {
                var _this = this;
                _this.$api.artlist({
                    // categoryCode
                    categoryCode:"QA3ABf"
                }).then(res => {
                    if (res.code == 200) {
                        console.log(res)
                        _this.list=res.data.list
                        // this.$message({
                        //     message: '登录成功！',
                        //     type: 'success',
                        // });
                       
                    } else {
                        _this.$message.error(res.msg);
                    }
                }).catch(function (error) {
                    _this.$message.error(error.msg);
                });
            },
            // 跳转详情页   
            ondel(item){
                this.$router.push('/details/'+item.code)
            },
           
            onSystem(){
                this.$router.push('/Leadership_Development')
            },
            onOfficers(){
                this.$router.push('/Organizational_Development')
            },
            onSearch(){
                this.$router.push('/Social_Development')
            },
            onResearch(){
                this.$router.push('/Professional_Research')
            }
        },
        created() {

        },
        mounted() {
            this.artlist()
        }
    }
</script>
<style scoped>

</style>